<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p>First published in the United States of America in 2014 by Chronicle Books LLC.</p>
<p>First published in Sweden in 2013 by Norstedts.</p>
<p>Copyright © 2013 by Ida Magntorn and Norstedts.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN: 978-1-4521-3717-9 (print)<br/>ISBN: 978-1-4521-4501-3 (epub2)<br/>ISBN: 978-1-4521-4520-4 (epub3)</p>
<p>Design, photography, and illustration:<br/>Ida Magntorn<br/>Production: Cecilia Ljungstrom<br/>Prepress: Fälth &amp; Hässler</p>
<p>City map of New York, <span href="#/xhtml/09chapter03#page_78" title="Link target outside of Sample">pages 78</span>–<span href="#/xhtml/09chapter03#page_79" title="Link target outside of Sample">79</span>: Map provided courtesy of Esri. Data for the map provided courtesy of Esri, DeLorme, NAVTEQ, increment P Corp., EPA, USGS, and NPS.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03copyright.vue?428b562c